
<template>
  <div class="apply_box">
    <div id="mescroll"
         class="mescroll noticeBox">
      <div>
        <div class="imgBg"
             v-if="isShowToast">
          <img @click="toUrl"
               :src="toastJson.imageUrl"
               alt="">
        </div>
<!--        <div class="bg"></div>-->
        <div class="item"
             v-if="orderList.length>0">
          <div class="box"
               v-for="(item,index) in orderList"
               :key="index">
            <div class="list"
                 @click="toPageUrl(item)">
              <p class="tl_box">
                <img class="logo_icon"
                     :src="item.productIcon" />
                <span class="title">{{item.productName}}</span>
                <!-- 30、31、32、34、140、141表示已拒绝状态 -->
                <span class="btn right"
                      v-if="orderType != 2"
                      :class="{'btn_status1':item.productType==40 || item.productType==100,'colorRed': orderType==3&&(item.productType ==30 || item.productType ==140 || item.productType==31 || item.productType ==141 || item.productType ==32 || item.productType==34)}">{{item.productTypeText}}</span>
                <!-- <span class="btn right"
                      v-if="orderType == 3"
                      :class="{'btn_status1':item.productType==40 || item.productType==100,'colorRed': item.productType ==30 || item.productType ==140 || item.productType!=31 || item.productType ==141 || item.productType ==32 || item.productType==34}">{{item.productTypeText}}</span> -->
              </p>
              <div class="dis_box">
                <div class="con_box">
                  <p><span>金额:</span> &nbsp;<span class="money">￥{{item.productMoney/100}}</span></p>
                  <p><span>期限:</span> &nbsp;<span>{{item.productTerm}}</span></p>
                  <p><span>申请时间:</span> &nbsp;<span>{{item.productApplyTime}}</span></p>
                </div>
                <div class="btn_box">
                  <!-- <span class="btn_reject"
                        v-if="item.productType==30 || item.productType==140"></span>
                  <span class="btn"
                        v-if="orderType == 2 || orderType == 1 && item.productType!=40">查看详情</span>
                  <span class="btn btn_status1"
                        v-if="item.productType==40">去操作</span>
                  <span class="btn btn_status1"
                        v-if="orderType == 3 && item.hasAgainApply == 1">再次申请</span> -->
                  <!-- 30、31、32、34、140、141表示已拒绝状态 -->
                  <!-- <span v-if="item.productType==30 || item.productType==32 || item.productType==34 ||item.productType==141 ||item.productType==140 || item.productType==31">{{item.title}}</span> -->
                  <span v-if="item.hasAgainApply==0&&item.title==''&&orderType==3"></span>
                  <span class="btn" v-if="item.title"
                        v-else
                        :class="{'btn_status1':item.hasAgainApply||item.productType==40,'btn_status2':item.productType==30 || item.productType==32 || item.productType==34 ||item.productType==141 ||item.productType==140 || item.productType==31}">{{item.title}}</span>
                </div>
              </div>
            </div>
            <div class="bg"
                 v-if="index!=orderList.length-1"></div>
          </div>
        </div>
        <div v-if="noData"
             class="noData">
          <img class="noBg"
               src="../../assets/img/afterLoan/noData.png"
               alt="">
          <div v-if="orderType==1 && finishListSize>0">
            <div style="font-size: 0.18rem;font-weight: 400;color: #CCCCCC;margin: 0.15rem auto 0.08rem;">抱歉，当前没有申请中的订单！</div>
            <div @click="toFinish" style="font-size: 0.15rem;font-weight: 400;color: #3B72FF;">查看已完成的订单 ></div>
          </div>
          <div v-else>
            <p class="noText">暂无订单</p>
          </div>
        </div>

        <div class="footer">
          本平台做为第三方需求信息发布平台，页面仅记录第三方机构接单48小时内的订单状态；页面订单不作任何实际交易依据，具体请以接单的第三方金融机构为准
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import MeScroll from 'mescroll.js'
import 'mescroll.js/mescroll.min.css'
export default {
  components: {
    MeScroll
  },
  data () {
    return {
      orderType: '',//失败成功的标志
      orderList: [],
      noData: false,
      isShowToast: 0,
      toastJson: {},
      finishListSize: 0,
    }
  },
  mounted () {
    this.orderType = this.$route.query.orderType;
    if (this.orderType == 1) {
      this.util.title('申请中');
      this.getAdver();
      this.getDetails(this.orderType);
      this.getFinishList(3);
    } else if (this.orderType == 2) {
      this.util.title('还款中');
      this.getDetails(this.orderType);
    } else if (this.orderType == 3) {
      this.util.title('已完成');
      this.getAdv();
      this.getDetails(this.orderType);
    }
    let _this = this;
    _this.mescroll = new MeScroll("mescroll", { //请至少在vue的mounted生命周期初始化mescroll,以确保您配置的id能够被找到
      down: {
        clearEmptyId: "noticeBox",
        empty: {
          tip: "暂无相关数据~", //提示
        },
        auto: false,//自动加载
        isBounce: false,
        callback: _this.downCallback
      },
    });
  },
  methods: {
    toUrl () {
      if (this.orderType == 3){
        window.location.href = this.toastJson.advertisingPageUrl;
      }else {
        window.location.href = this.toastJson.pageUrl;
      }
    },
    getAdver () {
      let _this = this;
      this.$get('/app/api/v1/ad/loanPage', { type: 18 })
        .then(res => {
          if (res.code == 200) {
            if (res.data) {
              _this.toastJson = res.data;
              _this.isShowToast = 1;
            } else {
              _this.isShowToast = 0;
            }
          }
          else {
            this.util.toast({ msg: res.message })
          }
        })
        .catch(error => { });
    },
    getAdv () {
      let _this = this;
      this.$get('/app/api/v1/order/advertising', { orderType: this.orderType })
          .then(res => {
            if (res.code == 200) {
              if (res.data.hasAdvertising) {
                _this.toastJson = res.data;
                _this.isShowToast = 1;
              } else {
                _this.isShowToast = 0;
              }
            }
            else {
              this.util.toast({ msg: res.message })
            }
          })
          .catch(error => { });
    },
    downCallback () {
      this.getDetails();
      this.orderList = []//重置数组
      // //下拉刷新的回调
      this.mescroll.resetUpScroll();
    },
    //调用android和ios的方法
    toProductDetail (item) {
      let json = {
        "pageUrl": item.pageUrl,
        "advertisingPageUrl": item.advertisingPageUrl
      }
      try {
        window.webkit.messageHandlers.toProductDetail.postMessage(json);//ios
      } catch (err) {
        window.AppJs.toProductDetail(JSON.stringify(json));//android
      }
    },
    toPageUrl (item) {
      if (item.source == 1) {
        let param = {
          orderId: item.id
        }
        this.$get('/app/api/v1/order/agency/fit', param)
                .then(res => {
                  if (res.code == 200) {
                    window.location.href = res.data;
                  } else {
                    this.util.toast({msg: e.msg})
                  }
                })
                .catch(error => {
                  _this.mescroll.endErr()
                });
      } else {
        if (item.pageUrl) {
          window.location.href = item.pageUrl;
        }
      }
      // // 进入监测页面
      // if (item.hasAgainApply == '1' && this.orderType == 3) {
      //   //去产品申请详情页面
      //   this.toProductDetail(item);
      // } else {
      /*if (item.pageUrl) {
        window.location.href = item.pageUrl;
      }*/
      // if (this.orderType == 1 || this.orderType == 2 || item.hasAgainApply == '1') {
      //   window.location.href = item.pageUrl;
      // } else {
      //   return false;
      // }
      // }
    },
    getDetails () {
      let _this = this;
      let param = {
        orderType: this.orderType,
        pageSize: 1000,
        customerId: '3509',
      }
      this.$get('/app/api/v1/order/list', param)
        .then(res => {
          var e = res;
          if (e.code == 200) {
            _this.mescroll.endSuccess(); //无参
            this.orderList = e.data;
            if (e.data.length == 0) {
              _this.noData = true;
            }
          }
          else {
            _this.util.toast({ msg: e.msg })
          }
        })
        .catch(error => { _this.mescroll.endErr() });
    }, toFinish() {
      this.orderType = 3;
      this.util.title('已完成');
      this.getAdv();
      this.getDetails(this.orderType);
    }, getFinishList(orderType) {
      let _this = this;
      let param = {
        orderType: orderType,
        pageSize: 1000,
        customerId: '3509',
      }
      this.$get('/app/api/v1/order/list', param)
              .then(res => {
                var e = res;
                if (e.code == 200) {
                  this.finishListSize = e.data.length;
                }
              })
              .catch(error => {

              });
    },
  }

}
</script>
<style scoped>
.noData {
  text-align: center;
  padding-top: 1.14rem;
  width: 100%;
  height: 100%;
}
.noBg {
  width: 1.43rem;
  height: 1.22rem;
  margin: 0 auto;
}
.noText {
  color: #ccc;
  font-size: 0.15rem;
}
.apply_box {
  background: #f7f7f7;
  /* padding-top: 0.1rem; */
  width: 100%;
  height: 100%;
}
.imgBg {
  /*height: 0.95rem;*/
  /* margin-bottom: 0.1rem; */
}
.imgBg img {
  width: 100%;
  /*height: 0.95rem;*/
}
.list {
  padding: 0.15rem;
  padding-top: 0.05rem;
  background: #fff;
}
.bg {
  background: #f7f7f7;
  height: 0.1rem;
}
.tl_box {
  border-bottom: 1px solid #f5f5f5;
  padding-bottom: 0.1rem;
  line-height: 0.3rem;
}
.logo_icon {
  display: inline-block;
  width: 0.22rem;
  height: 0.22rem;
  border-radius: 3px;
  /* background: url("../../assets/img/afterLoan/add_btn.png") no-repeat top center; */
  /* background-size: 100% 100%; */
  position: relative;
  top: 0.05rem;
}

.title {
  font-size: 0.16rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  margin-left: 0.1rem;
}
.tl_box .btn {
  font-size: 0.16rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(186, 186, 186, 1);
}
.tl_box .btn_status1 {
  color: rgba(79, 140, 250, 1);
}
.con_box {
  color: #999;
  font-size: 0.12rem;
}
.con_box p {
  font-size: 0.12rem;
}
.money {
  font-size: 0.2rem;
  color: #484848;
  font-family: DINAlternate-Bold;
  font-weight: bold;
}
.gray {
  color: #bababa;
}
.con_box p {
  margin-bottom: 0.03rem;
}
.con_box p:last-child {
  margin-bottom: 0;
}
.dis_box {
  display: flex;
  justify-content: space-around;
  padding: 0.15rem 0;
  position: relative;
  padding-bottom: 0;
  padding-top: 0.1rem;
}
.con_box {
  flex: 0.75;
}
.btn_box {
  flex: 0.25;
  text-align: right;
}
.btn_box .btn,
.btn_box .btn_status2 {
  display: inline-block;
  width: 0.8rem;
  padding: 0.04rem 0;
  border-radius: 15px;
  border: 1px solid rgba(79, 140, 250, 1);
  text-align: center;
  position: relative;
  top: 0.22rem;
  font-size: 0.13rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: #4f8cfa;
}
.btn_box .btn_status1 {
  background: linear-gradient(
    132deg,
    rgba(89, 163, 252, 1) 0%,
    rgba(60, 100, 246, 1) 100%
  );
  color: #fff;
}
.btn_box .btn_reject {
  display: inline-block;
  width: 0.89rem;
  height: 0.89rem;
  background: url('../../assets/img/afterLoan/img_refuse.png') no-repeat top
    center;
  background-size: 100% 100%;
  position: absolute;
  right: -0.15rem;
  bottom: -0.15rem;
}

.btn_box .btn_status2 {
  background: linear-gradient(
    135deg,
    rgba(255, 172, 85, 1) 0%,
    rgba(255, 57, 31, 1) 100%
  );
  box-shadow: 0px 4px 10px 0px rgba(255, 191, 128, 0.2);
  border-radius: 15px;
  color: #fff;
  border: none;
  font-size: 0.13rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  padding: 0.05rem 0;
}
.tl_box .colorRed {
  color: #ff514a;
}
.tl_box .btn_status1 {
  color: #4f8cfa;
}
  .footer{
    margin-top: 100px;
    padding: 0rem 0.15rem;
    font-size: 0.1rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #CCCCCC;
  }
</style>
